import { IntegrationType } from 'routes/Integrations/helpers/types'
import { INTEGRATIONS_REVALIDATE_TIME, LINKS } from 'routes/constants'
import { fetchIntegration } from 'routes/Integrations/helpers'
import IntegrationScenariosPage from 'routes/Integrations/Integration/Scenarios'

export default function IntegrationScenarios({
  integration,
}: {
  integration: IntegrationType
}) {
  return <IntegrationScenariosPage integration={integration} />
}

export async function getStaticPaths() {
  // Fetch data from external API
  return {
    paths: [],
    fallback: true, // false or "blocking"
  }
}

export async function getStaticProps({ params }) {
  // Fetch data from external API
  const integrationKey = params.integrationKey

  try {
    const integration = await fetchIntegration(integrationKey)

    // Pass data to the page via props
    return {
      props: {
        integration,
      },
      revalidate: INTEGRATIONS_REVALIDATE_TIME, // In seconds
    }
  } catch (e) {
    // `redirect` can not be returned from getStaticProps during pre-rendering
    // During pre-rendering we can only return `notFound`
    if (process.env.npm_lifecycle_event === 'build') {
      return {
        notFound: true,
      }
    }
    return {
      redirect: {
        destination: LINKS.INTEGRATIONS,
        permanent: false,
      },
    }
  }
}
